// extracted by mini-css-extract-plugin
export default {"Name":"WorkPermitsOverview_Name__xxoQ1"};